var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sys-list"},[_c('div',{staticClass:"sys-list-c"},_vm._l((_vm.authSysList),function(item){return _c('div',{key:item.key,staticClass:"sys-list-item",class:{'sys-list-item-a': item.key === _vm.currentSys},on:{"click":function($event){return _vm.change(item.key)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }